import { render, staticRenderFns } from "./webHead.vue?vue&type=template&id=4948c1fc&scoped=true"
import script from "./webHead.vue?vue&type=script&lang=ts"
export * from "./webHead.vue?vue&type=script&lang=ts"
import style0 from "./webHead.vue?vue&type=style&index=0&id=4948c1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4948c1fc",
  null
  
)

export default component.exports